import { render, staticRenderFns } from "./AAsignarCobradorProg.vue?vue&type=template&id=47d1b12a"
import script from "./AAsignarCobradorProg.vue?vue&type=script&lang=js"
export * from "./AAsignarCobradorProg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports